import { jsxs as O, Fragment as tt, jsx as s } from "react/jsx-runtime";
import { QUERIES as ot, zIndices as et } from "@fcamna/shared-component-foundations";
import { c as N } from "./index-65016bfa.mjs";
import { forwardRef as nt, useRef as D, useState as F, useEffect as B, useCallback as g, useImperativeHandle as rt } from "react";
import { createPortal as it } from "react-dom";
import l, { css as f } from "styled-components";
import { u as pt } from "./usePopoverIndex-b3a93ecd.mjs";
import { u as st } from "./useQuantum-50e8fd44.mjs";
import { b as ct } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import { u as ut } from "./useSlots-a1aa6a84.mjs";
import { u as at } from "./useWindowSize-88e90e04.mjs";
import { Button as mt } from "./button.js";
import { CloseButton as lt } from "./closeButton.js";
import { Divider as Tt } from "./divider.js";
import { FocusTrap as dt } from "./focusTrap.js";
import { g as ft } from "./getElementPosition-a8642645.mjs";
import { Link as _t } from "./link.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./iconButton.js";
import "./icon.js";
import "@fcamna/shared-icons";
import "./useClient-0bbce34e.mjs";
var p = /* @__PURE__ */ ((t) => (t.AUTO = "auto", t.TOP = "top", t.BOTTOM = "bottom", t.LEFT = "left", t.RIGHT = "right", t.TOP_START = "top-start", t.TOP_END = "top-end", t.BOTTOM_START = "bottom-start", t.BOTTOM_END = "bottom-end", t.RIGHT_START = "right-start", t.RIGHT_END = "right-end", t.LEFT_START = "left-start", t.LEFT_END = "left-end", t))(p || {});
const q = l.div`
  &.PopupTip {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.PopupTip)};
  }
`, ht = l.div`
  &.PopupTip__overlay {
    ${({
  theme: {
    components: { popupTip: t }
  },
  $zIndex: o
}) => f(t.MobileFixedOverlay, {
  [`@media ${ot.mobile}`]: {
    zIndex: o
  }
})};
  }
`, Pt = l.div`
  &.PopupTip__content-wrapper {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.ContentWrapper)};
  }
`, gt = l.div`
  &.PopupTip__content {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Content)};
  }
`, Ot = l.div`
  &.PopupTip__header {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Header)};
  }
`, $t = l.div`
  &.PopupTip__title {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Title)};
  }
`, St = l.div`
  &.PopupTip__body {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Body)};
  }
`, bt = l.div`
  &.PopupTip__footer {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Footer)};
  }
`, vt = l.span`
  &.PopupTip__pointer {
    ${({
  theme: {
    components: { popupTip: t }
  }
}) => f(t.Pointer)};
  }
`, Ct = (t, o, e, n) => {
  const r = t.getBoundingClientRect(), $ = o.clientHeight + 1, h = o.clientWidth + 1, _ = r.top < $, u = r.left < h, a = r.right + h > e - 1, T = r.bottom + $ > n - 1, L = _ && a, w = _ && u, d = T && u, k = T && a;
  if (!(!_ && !a && !u && !T))
    return !_ && !a && !u ? p.TOP : d && !_ && !a ? p.TOP_END : k && !_ && !u ? p.TOP_START : !T && !a && !u ? p.BOTTOM : w && !T && !a ? p.BOTTOM_END : L && !T && !u ? p.BOTTOM_START : a && !u ? p.LEFT : !a && u ? p.RIGHT : p.TOP;
}, V = nt(
  ({
    open: t,
    children: o,
    placement: e = p.AUTO,
    popupTipHeader: n,
    popupTipBody: r,
    className: $,
    isDisabled: h,
    CTAButtonHandler: _,
    CTAButtonLabel: u = "Button",
    showButton: a,
    accessibilityOptions: T = { closeButton: { ariaLabel: "CloseButton" } },
    showTitleBorder: L = !0,
    hideTitleDivider: w = !L,
    exceedOverflow: d,
    neverCloseOnClickOutside: k,
    timeout: A,
    ...W
  }, J) => {
    const z = st({ label: "Popup Tip" }), P = D(null), C = D(null), S = D(), [X, H] = F({}), { width: M, height: x } = at(), [c, b] = F(t);
    B(() => b(t), [t]);
    const U = pt(c, V.zIndex), [m, G] = F(
      e === p.AUTO ? p.TOP : e
    );
    B(() => {
      G(e === p.AUTO ? p.TOP : e);
    }, [e]);
    const Y = ct("button", T.CTAButton || {}), K = g(() => {
      if (!P.current || !C.current || d)
        return;
      const i = Ct(P.current, C.current, M, x);
      i && i !== m && G(i);
    }, [d, m, x, M]);
    B(() => {
      if (c)
        return K(), !S.current && A && (S.current = setTimeout(() => b(!1), A)), () => {
          S.current && (clearTimeout(S.current), S.current = void 0);
        };
    }, [c, K, A]);
    const R = g(() => {
      h || b(!0);
    }, [h]), v = g(() => {
      b(!1);
    }, []), y = g(() => {
      h || b((i) => !i);
    }, [h]), j = g(
      (i) => {
        const E = i.key === "Enter", Z = i.key === " " || i.code === "Space";
        !E && !Z || (i.preventDefault(), R());
      },
      [R]
    ), I = g(() => {
      if (!c || !d)
        return H({});
      const i = ft(P, C, m, "popuptip");
      H(i);
    }, [d, c, m]);
    B(() => I(), [I]), ut("scroll", I, void 0, !0), rt(J, () => ({ open: R, close: v, toggle: y }), [
      v,
      R,
      y
    ]);
    const Q = () => /* @__PURE__ */ s(
      ht,
      {
        $zIndex: U,
        className: "PopupTip__overlay",
        children: /* @__PURE__ */ s(
          dt,
          {
            open: c,
            disableEnforceFocus: !0,
            disableScrollFocusInView: !0,
            onFocusedOutside: (i) => {
              var E;
              c && !((E = P.current) != null && E.contains(i.target)) && !k && v();
            },
            onClick: (i) => i.stopPropagation(),
            onKeyDown: (i) => {
              i.stopPropagation(), c && i.code === "Escape" && v();
            },
            children: /* @__PURE__ */ O(
              Pt,
              {
                ref: C,
                role: "dialog",
                "aria-hidden": !c,
                "aria-label": n,
                className: N([
                  "PopupTip__content-wrapper",
                  `PopupTip__content-wrapper--${m}`,
                  {
                    "PopupTip__content-wrapper--open": c,
                    [`PopupTip__content-wrapper--${m}-open`]: c,
                    "PopupTip__content-wrapper--overflown": d,
                    [`PopupTip__content-wrapper--overflown-${m}`]: d
                  }
                ]),
                style: { ...X, zIndex: U },
                children: [
                  /* @__PURE__ */ O(gt, { className: "PopupTip__content", children: [
                    !!n && /* @__PURE__ */ O(Ot, { className: "PopupTip__header", children: [
                      /* @__PURE__ */ s($t, { className: "PopupTip__title", children: n }),
                      /* @__PURE__ */ s(
                        lt,
                        {
                          ariaLabel: "CloseButton",
                          accessibilityOptions: T.closeButton,
                          className: "PopupTip__close-btn",
                          onClick: v,
                          size: "xsmall"
                        }
                      )
                    ] }),
                    !w && !!n && /* @__PURE__ */ s(Tt, { className: "PopupTip__Divider" }),
                    /* @__PURE__ */ s(St, { className: "PopupTip__body", children: r }),
                    a && /* @__PURE__ */ s(bt, { className: "PopupTip__footer", children: /* @__PURE__ */ s(
                      mt,
                      {
                        ...Y,
                        className: "PopupTip__footer-CTA-btn",
                        size: "small",
                        variant: "solid",
                        fullWidth: !0,
                        onClick: _,
                        children: u
                      }
                    ) })
                  ] }),
                  /* @__PURE__ */ s(
                    vt,
                    {
                      className: N([
                        "PopupTip__pointer",
                        `PopupTip__pointer--${m.split("-")[0]}`,
                        `PopupTip__pointer--${m}`
                      ])
                    }
                  )
                ]
              }
            )
          }
        )
      }
    );
    return d ? /* @__PURE__ */ O(tt, { children: [
      /* @__PURE__ */ s(
        q,
        {
          ...z,
          ...W,
          className: N(["PopupTip", `PopupTip--${m}`, $]),
          ref: P,
          onClick: y,
          onKeyDown: j,
          children: o
        }
      ),
      c && (!!n || !!r) && it(Q(), document.body)
    ] }) : /* @__PURE__ */ O(
      q,
      {
        ...z,
        ...W,
        className: N(["PopupTip", `PopupTip--${m}`, $]),
        ref: P,
        onClick: y,
        onKeyDown: j,
        children: [
          o,
          (!!n || !!r) && Q()
        ]
      }
    );
  }
);
V.zIndex = et.popover;
const Rt = l.div`
  position: ${(t) => {
  var o, e, n, r;
  return (r = (n = (e = (o = t == null ? void 0 : t.theme) == null ? void 0 : o.components) == null ? void 0 : e.popupTip) == null ? void 0 : n.LinksWrapper) == null ? void 0 : r.position;
}};
  display: ${(t) => {
  var o, e, n, r;
  return (r = (n = (e = (o = t == null ? void 0 : t.theme) == null ? void 0 : o.components) == null ? void 0 : e.popupTip) == null ? void 0 : n.LinksWrapper) == null ? void 0 : r.display;
}};
  padding: ${(t) => {
  var o, e, n, r;
  return (r = (n = (e = (o = t == null ? void 0 : t.theme) == null ? void 0 : o.components) == null ? void 0 : e.popupTip) == null ? void 0 : n.LinksWrapper) == null ? void 0 : r.padding;
}};
`, yt = l.span`
  margin: ${(t) => {
  var o, e, n, r;
  return (r = (n = (e = (o = t == null ? void 0 : t.theme) == null ? void 0 : o.components) == null ? void 0 : e.popupTip) == null ? void 0 : n.DividerLink) == null ? void 0 : r.margin;
}};
  color: ${(t) => {
  var o, e, n, r;
  return (r = (n = (e = (o = t == null ? void 0 : t.theme) == null ? void 0 : o.components) == null ? void 0 : e.popupTip) == null ? void 0 : n.DividerLink) == null ? void 0 : r.color;
}};
`, oo = ({ links: t }) => /* @__PURE__ */ s(Rt, { children: t.map((o, e) => /* @__PURE__ */ O("div", { children: [
  /* @__PURE__ */ s(
    _t,
    {
      to: o.url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: o.title
    }
  ),
  e !== t.length - 1 && /* @__PURE__ */ s(yt, { children: " | " })
] }, o.id)) });
export {
  p as PopupPlacement,
  V as PopupTip,
  oo as PopupTipLinks,
  Ct as getPosition
};
